import React, { useCallback, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { InputNumber } from 'antd'
import { formatPrice } from '../../../../utils/index';


const OutputTypeTable = ({ disabled, uniformPrice = false }) => {
    const methods = useFormContext();
    const { watch } = methods
    // const [isModelProduct, setIsModelProduct] = useState(false);
    // const [isImportExcel, setIsImportExcel] = useState(false)
    // const [totalPages, setTotalPages] = useState(0);
    // const [totalItems, setTotalItem] = useState(0)


    const changePriceBasic = useCallback((value, idx) => {
        value = Number(value)

        let list_output_type_submit = methods.watch('list_output_type_submit')
        let output_type_rows = methods.watch('output_type_rows') || {}
        if (!list_output_type_submit?.[idx]) return;
        const vat_value = list_output_type_submit[idx].vat_value * 1
        
        const _price_vat = methods.watch('price_vat') + value
        
        // công thức cũ tính change_price
        // const _prices = structuredClone(methods.watch('base_price'));
        // let numberAbide = (value + Number(_prices)) * (100 + vat_value);
        // let roundPrice = Math.round(numberAbide / 100);

        list_output_type_submit[idx].base_price =  Math.round(Number(_price_vat) / Number((100 + vat_value)/100));
        list_output_type_submit[idx].price = _price_vat
        list_output_type_submit[idx].change_value = value;
        list_output_type_submit[idx].change_price = _price_vat;

        methods.setValue("list_output_type_submit", list_output_type_submit);
        methods.setValue("output_type_rows", {
            ...output_type_rows,
            [idx]: {
                ...output_type_rows[idx],
                ...list_output_type_submit[idx],
            },
        });
    }, [methods])





    const columns = useMemo(
        () => [
            {
                header: 'STT',
                classNameHeader: 'bw_sticky bw_check_sticky bw_text_center',
                classNameBody: 'bw_text_center',
                formatter: (p, idx) => <span className='bw_sticky bw_name_sticky'>{idx + 1}</span>,
            },
            {
                header: 'Hình thức xuất',
                formatter: (p) => <p>{p?.output_type_name}</p>,
            },
            ...(!uniformPrice ? [{
                header: 'Chênh lệch giá (đ)',
                formatter: (p) => {
                    if (p?.is_primary) {
                        return <span className='bw_price_output_base'>Giá chuẩn</span>;
                    }
                    return (
                        <InputNumber
                            className='bw_price_output_adjust_input'
                            controls={false}
                            disabled={disabled}
                            value={p?.change_value}
                            formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                            onChange={(value) => changePriceBasic(value, p?.output_type_id)}
                            placeholder='0'
                        />
                    )
                },
            }] : []),
            {
                header: 'Giá bán có VAT (đ)',
                classNameHeader: 'bw_text_right',
                classNameBody: 'bw_text_right',
                formatter: (p) => <strong className='bw_price_output_value'>{formatPrice(p?.price, false, ',')} VNĐ</strong>,
            },
            {
                header: 'Giá chưa VAT (đ)',
                classNameHeader: 'bw_text_right',
                classNameBody: 'bw_text_right',
                formatter: (p) => <span className='bw_price_output_base'>{formatPrice(p?.base_price, false, ',')} VNĐ</span>,
            },

        ],
        [changePriceBasic, disabled, uniformPrice],
    );

    const renderData = useCallback(
        (valueRender, keyRender) => (
            <tr>
                {columns?.map((column, key) => {
                    if (column.formatter) {
                        return (
                            <td className={column?.classNameBody} key={`${keyRender}${key}`}>
                                {column?.formatter(valueRender, keyRender)}
                            </td>
                        );
                    } else if (column.accessor) {
                        return (
                            <td className={column?.classNameBody} key={`${keyRender}${key}`}>
                                {valueRender[column.accessor]}
                            </td>
                        );
                    } else {
                        return <td className={column?.classNameBody} key={`${keyRender}${key}`}></td>;
                    }
                })}
            </tr>
        ),
        [columns],
    );
    const outputTypeRows = Object.values(watch('output_type_rows') || {});

    return (
        <React.Fragment>
            <div className='bw_price_output_table_header'>
                <div>
                  <p>Giá theo hình thức xuất</p>
                    <span>
                      {uniformPrice
                        ? `${outputTypeRows.length} hình thức dùng chung một giá combo`
                        : `${outputTypeRows.length} hình thức đã chọn`}
                    </span>
                </div>
            </div>
            <div className='bw_table_responsive bw_price_output_table'>
                <table className='bw_table'>
                    <thead>
                        <tr>
                            {columns?.map((p, idx) => (
                                <th key={idx} className={p?.classNameHeader}>{p?.header}</th>
                            ))}
                        </tr>
                    </thead>

                    <tbody>
                        {outputTypeRows.length ? (
                            outputTypeRows?.map((value, key) => {
                                return renderData(value, key);
                            })
                        ) : (
                            <tr>
                                <td colSpan={columns.length} className='bw_text_center bw_price_output_empty'>
                                    Chưa có hình thức xuất phù hợp
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
{/*
            {watch('list_output_type_submit') && Object.values(watch('list_output_type_submit')).length > itemsPerPage ? (
                <div className='bw_row bw_mt_2 bw_show_table_page'>
                    <div className='bw_col_6'>
                        <p>
                            Show{' '}
                            {totalItems < 15 ? totalItems : itemsPerPage}/{totalItems} records
                        </p>
                    </div>

                    <div className='bw_col_6 bw_flex bw_justify_content_right bw_align_items_center'>
                        <div className='bw_nav_table'>
                            <button
                                disabled={!(Boolean(page) && parseInt(page) !== 1)}
                                onClick={() => {
                                    setpage(parseInt(page) - 1);
                                }}
                                className={Boolean(page) && parseInt(page) !== 1 && 'bw_active'}>
                                <span className='fi fi-rr-angle-small-left'></span>
                            </button>
                            <input type='number' value={parseInt(page)} step='1' max={totalPages} />
                            <span className='bw_all_page'>/ {totalPages}</span>
                            <button
                                disabled={parseInt(totalPages) === parseInt(page)}
                                onClick={() => {
                                    setpage(parseInt(page) + 1);
                                }}
                                className={!(parseInt(totalPages) === parseInt(page)) && 'bw_active'}>
                                <span className='fi fi-rr-angle-small-right'></span>
                            </button>
                        </div>
                    </div>
                </div>
            ) : null} */}

        </React.Fragment>
    );
};

export default OutputTypeTable;
